/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React, { useEffect, useState, useCallback } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser, faBarcode, faPhone, faAddressCard, faHome, faPeopleArrows, faCode, faSave } from "@fortawesome/free-solid-svg-icons"
import { Badge, Breadcrumb, Button, Card, Col, ProgressBar, Row, Table, Dropdown, ButtonGroup, Form, InputGroup } from '@themesberg/react-bootstrap'
import _ from 'lodash'
import { useDispatch, useSelector } from "react-redux"
import ReceiverAction from '../../core/redux/action/ReceiverAction'
import Progress from "../../components/Progress"
import { GetResultObject, PostRequest } from '../../core/API'
import { ApiSrc } from '../../resources/ApiSrc'


export default (props) => {

    const [firstName, setFirstName] = useState()
    const [lastName, setLastName] = useState()
    const [sex, setSex] = useState()
    const [phone, setPhone] = useState()
    const [wrongPhone, setWrongPhone] = useState()
    const [accountNo, setAccountNo] = useState()
    const [address, setAddress] = useState()
    const [countryCode, setCountryCode] = useState('855')
    const [postalCode, setPostalCode] = useState()
    const [expressId, setExpressId] = useState()
    const [progressValue, setProgressValue] = useState();

    const dispatch = useDispatch();

    const escFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            props.onClose && props.onClose()
        }
    }, [props]);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    const onSave = () => {
        const body = {
            expressId,
            firstName,
            lastName,
            sex,
            phone,
            address,
            countryCode,
            expressId,
            accountNo
        }

        console.log('>> body', body)
        // dispatch(ReceiverAction.createReceiver({input: {...body}, token: null}));
        // props.onClose && props.onClose()
        setProgressValue(30)
        PostRequest(ApiSrc.CREATE_RECEIVER, { input: { ...body }, token: null }).then(result =>
            GetResultObject(result, 'data', 200, (data) => {
                setProgressValue(100)
                dispatch(ReceiverAction.createReceiverSuccess(data));
                let timer = setInterval(function () {
                    props.onClose && props.onClose(timer)
                }, 1000);
            })
        )
    }

    const onPhoneChange = (e) => {
        var value = e.target.value
        const reg = /^[1-9][0-9]\d{3}\d{3}/;
        if (reg.test(value) === false) {
            console.log(">reg false", value)
            setPhone(value == "" ? undefined : value)
            setWrongPhone(value == "" ? undefined : "Invalid Phone")
            return false;
        } else {
            console.log(">reg true", value)
            setWrongPhone(undefined)
            setPhone(value)
            return true;
        }
    }

    return (
        <>
            {
                progressValue !== undefined && (<Progress variant="success" label="Progress..." value={progressValue ?? 1} />)
            }
            <Card>
                <Card.Header>
                    <h6>Create New User</h6>
                </Card.Header>
                <Card.Body>
                    <Form>
                        <Row>
                            <Col xs={12} sm={6} xl={6}>
                                <Row>
                                    <Col xs={12} sm={6} xl={6}>
                                        <Col xs={12} sm={6} xl={6}>
                                            <Form.Label>First Name</Form.Label>
                                        </Col>
                                        <Col>
                                            <InputGroup>
                                                <InputGroup.Text >
                                                    <FontAwesomeIcon icon={faUser} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text"
                                                    onChange={(e) => setFirstName(e.target.value.trim())}
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Col>
                                    <Col xs={12} sm={6} xl={6}>
                                        <Col xs={12} sm={6} xl={6}>
                                            <Form.Label>Last Name</Form.Label>
                                        </Col>
                                        <Col>
                                            <InputGroup>
                                                <InputGroup.Text >
                                                    <FontAwesomeIcon icon={faUser} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text"
                                                    onChange={(e) => setLastName(e.target.value.trim())} />
                                            </InputGroup>
                                        </Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Sex</Form.Label>
                                                    <InputGroup>
                                                        <Form.Select onChange={(e) => {
                                                            setSex(e.target.value == e.target.value == "--Select--" ? undefined : e.target.value)
                                                        }}>
                                                            <option>--Select--</option>
                                                            <option>Male</option>
                                                            <option>Female</option>
                                                        </Form.Select>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Col>
                                            <Form.Label>Account No#</Form.Label>
                                        </Col>
                                        <Col>
                                            <InputGroup>
                                                <InputGroup.Text >
                                                    <FontAwesomeIcon icon={faBarcode} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text"
                                                    //  onChange={(e)=>setAccountNo(e.target.value)} 
                                                    placeholder="Auto"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4} sm={4} xl={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Country Code</Form.Label>
                                            <InputGroup>
                                                <Form.Select onChange={(e) => {
                                                    setCountryCode(e.target.value)
                                                }}>
                                                    <option>855</option>
                                                </Form.Select>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={8} sm={8} xl={8}>
                                        <Col>
                                            <Form.Label>Phone Number</Form.Label>
                                        </Col>
                                        <Col>
                                            <InputGroup>
                                                <InputGroup.Text >

                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text"
                                                    onChange={onPhoneChange} />
                                            </InputGroup>
                                        </Col>
                                        <Col>
                                            <label className={"text-danger"}>{wrongPhone}</label>
                                        </Col>
                                    </Col>
                                </Row>
                            </Col>
                            <Col></Col>
                        </Row>
                    </Form>
                </Card.Body>

                <Card.Footer>
                    <Button onClick={onSave}><FontAwesomeIcon icon={faSave} /> Save</Button>
                </Card.Footer>
            </Card>
        </>
    )
}